<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';

// 複数AI並行(別worktree)時に「今どのWFか」「今何をしているか」を人間へ見せる dev 専用フッター帯。
// VITE_WF_LABEL が設定されている時だけ表示。本番/通常devでは未設定=非表示。
// 1行目: 固定（対応中の AI-WF ID + タイトル）
// 2行目: 動的（操作のたびに window.__setWfStatus('…') / CustomEvent 'wf-status' で更新）
const label = import.meta.env.VITE_WF_LABEL as string | undefined;
const port = import.meta.env.VITE_DEV_PORT as string | undefined;

const status = ref<string>('待機中');

function applyStatus(msg: string) {
  status.value = msg;
  (window as unknown as { __wfStatusMsg?: string }).__wfStatusMsg = msg;
}
function onEvent(e: Event) {
  applyStatus(String((e as CustomEvent).detail ?? ''));
}

onMounted(() => {
  const w = window as unknown as { __wfStatusMsg?: string; __setWfStatus?: (m: string) => void };
  if (w.__wfStatusMsg) status.value = w.__wfStatusMsg; // 画面遷移後も直近の状態を復元
  w.__setWfStatus = applyStatus; // 操作側から呼ぶ更新口
  window.addEventListener('wf-status', onEvent as EventListener);
});
onUnmounted(() => window.removeEventListener('wf-status', onEvent as EventListener));
</script>

<template>
  <div v-if="label" class="wf-dev-banner">
    <div class="wf-line1">🤖 {{ label }}<span v-if="port"> ｜ :{{ port }}</span></div>
    <div class="wf-line2">▶ {{ status }}</div>
  </div>
</template>

<style scoped>
.wf-dev-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2147483647;
  background: #7e57c2;
  color: #fff;
  padding: 8px 16px;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
  box-shadow: 0 -3px 14px rgba(0, 0, 0, 0.45);
  pointer-events: none;
}
.wf-line1 {
  font: 800 20px/1.4 system-ui, sans-serif;
  letter-spacing: 0.05em;
}
.wf-line2 {
  font: 700 16px/1.5 system-ui, sans-serif;
  letter-spacing: 0.03em;
  color: #ffe082;
}
</style>
